import React from 'react'
import createMeasurement from './Measurements'

class Graph extends React.Component {
  render() {
    const { className, measurement = createMeasurement({}) } = this.props
    return (
      <svg
        className={className}
        width={measurement.width}
        height={measurement.height}
      >
        {this.props.children}
      </svg>
    )
  }
}
export default Graph
